if (!customElements.get('product-tile')) {
  let _yotpoAppKey = null;
  const _cache = {};

  class ProductTile extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
    }

    connectedCallback() {
      if (this.productId) this.fetchYotpoBottomline();
    }

    getYotpoAppKey() {
      if (_yotpoAppKey) return _yotpoAppKey;
      for (const script of document.querySelectorAll('script[src*="yotpo"]')) {
        const match =
          script.src.match(/staticw2\.yotpo\.com\/([^/]+)\//) ||
          script.src.match(/cdn-widgetsrepository\.yotpo\.com\/v1\/loader\/([^?/]+)/);
        if (match?.[1]) return (_yotpoAppKey = match[1]);
      }
      return null;
    }

    async fetchYotpoBottomline() {
      const appKey = this.getYotpoAppKey();
      if (!appKey) return;

      if (_cache[this.productId]) {
        return this.updateDisplay(_cache[this.productId]);
      }

      const storageKey = `yotpo_bl_${this.productId}`;
      try {
        const stored = sessionStorage.getItem(storageKey);
        if (stored) {
          _cache[this.productId] = JSON.parse(stored);
          return this.updateDisplay(_cache[this.productId]);
        }
      } catch (_) {}

      try {
        const res = await fetch(
          `https://api.yotpo.com/v1/widget/${appKey}/products/${this.productId}/bottomline.json`
        );
        if (!res.ok) return;
        const { response } = await res.json();
        const bottomline = response?.bottomline;
        if (!bottomline) return;
        _cache[this.productId] = bottomline;
        try { sessionStorage.setItem(storageKey, JSON.stringify(bottomline)); } catch (_) {}
        this.updateDisplay(bottomline);
      } catch (e) {
        console.warn('ProductTile: Yotpo fetch failed', e);
      }
    }

    updateDisplay({ average_score, total_review }) {
      const score = parseFloat(average_score) || 0;
      const total = parseInt(total_review) || 0;

      const ratingEl = this.querySelector('.review-rating');
      const noReviewsEl = this.querySelector('.ss__results__no-reviews');
      const scoreEl = this.querySelector('.review-score');
      const totalEl = this.querySelector('.review-total');

      if (score > 0) {
        if (ratingEl) ratingEl.style.display = 'flex';
        if (noReviewsEl) noReviewsEl.style.display = 'none';
        if (scoreEl) scoreEl.textContent = score.toFixed(1);
        if (totalEl) totalEl.textContent = `(${total})`;
      } else {
        if (ratingEl) ratingEl.style.display = 'none';
        if (noReviewsEl) noReviewsEl.style.display = 'block';
      }
    }
  }

  customElements.define('product-tile', ProductTile);
}
